<template>
	<div class="recharge-page withdraw add-address-page clear">
		<top-bar :title="i18n.t('addAddress.title')" @back="back"></top-bar>


		<div class="form-label">{{i18n.t('addAddress.label1')}}</div>

		<div class="recharge-list">
			<div class="list flex-center" >
				<div class="icon">
					<img :src="rechargeInfo.icon" alt="">
				</div>
				<div class="name flex-1">
					<span>{{rechargeInfo.name}}</span>
				</div>
			</div>
		</div>

		<div class="form-label">{{i18n.t('addAddress.label2')}}</div>

		<div class="form-input">
			<input type="text" v-model="form.address" :placeholder="i18n.t('addAddress.labelPlaceholder2')">
		</div>

		<div class="form-label gray">{{i18n.t('addAddress.label4')}}</div>
		<div class="desc">{{ $t('addAddress.desc1', [rechargeInfo.name]) }}</div>

		<div class="bottom-btn flex-center">
			<Button  class="big" @click="submit">{{i18n.t('addAddress.btn1')}}</Button>
		</div>


	</div>
</template>
<script>
import topBar from '@/components/topBar'
import { Popup, Button } from 'vant'
import { bindWithdrawAddress, updateWithdrawAddress } from '@/api/assest'
export default {
	components: {
    Popup,
    Button,
		topBar
  },
  data() {
		return {
			form: {
				address: '',
				protocol: '',
				id: '',
			},
			closeUrl: require('../../assets/imgs/icon-close.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
			logUrl: require('../../assets/imgs/icon-log.png'),
			iconObj:{
        'USDT-TRC20':  require('../../assets/imgs/bit1.png'),
        'USDT-ERC20':  require('../../assets/imgs/bit2.png'),
        'USDC-TRC20':  require('../../assets/imgs/bit5.png'),
        'USDC-ERC20':  require('../../assets/imgs/bit5.png'),
        'ETH-ERC20':  require('../../assets/imgs/bit3.png'),
        'BTC':  require('../../assets/imgs/bit4.png'),
      },
			showRecharge: false,
      rechargeIndex: 0,
			rechargeInfo: {},
			rechargeInfoBak: {},
			addressData: []
		}
	},
	computed: {
		isEditMode() {
			return this.$route.query.mode === 'edit'
		}
	},
  mounted() {
		let data = sessionStorage.getItem('bitInfo')

		if (data) {
			this.rechargeInfo = JSON.parse(data)
			this.form.protocol = this.rechargeInfo.key
		}

		if (this.isEditMode) {
			const query = this.$route.query
			this.form.id = query.id || ''
			this.form.address = query.address || ''
			this.form.protocol = query.protocol || this.form.protocol

			if (!this.rechargeInfo.key && this.form.protocol) {
				this.rechargeInfo = this.getRechargeInfo(this.form.protocol)
			}
		}
  },
	methods: {
		getRechargeInfo(protocol) {
			return {
				icon: this.iconObj[protocol],
				name: protocol,
				key: protocol
			}
		},
		back() {
			this.$router.go(-1)
		},
		chooseRecharge() {
      this.showRecharge = true
    },
    changeRecharge(data, i) {
      this.rechargeIndex = i
			this.form.protocol = data.key
    },
		cancel() {
			this.showRecharge = false
		},
		submit() {
			const address = String(this.form.address || '').trim()
			if (!address) {
				this.$toast.fail(this.i18n.t('addAddress.labelPlaceholder2'))
				return
			}

			let form = new FormData()
			form.append('Address', address)
			const request = this.isEditMode ? updateWithdrawAddress : bindWithdrawAddress

			if (this.isEditMode) {
				form.append('Id', this.form.id)
			} else {
				form.append('Protocol', this.form.protocol)
			}

			request(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('common.success'))
					setTimeout(() => {
						sessionStorage.setItem('withdrawInit', 1)
						this.back()
					}, 1500);
				} else {
				 this.$toast.fail(res.msg)
				}
			})
		}
	}
}
</script>
